import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import TranslationService from "./../../Services/translationService";
import ApiService from "./../../Services/apiService";
import NoDataImage from "../../assets/images/illustrations/nodata.svg";
import { Link, withRouter } from "react-router-dom";
import EditSvg from "../../Components/Svg/editSvg";
import GameSvg from "../../Components/Svg/gameSvg";
import ModalComponentWithoutActionButton from "../../Components/ModalComponent/modalComponentWithoutActionButton";
import {
	addPartialViewSpinner,
	removePartialViewSpinner,
	addModalSpinner,
	removeModalSpinner,
} from "./../../Store/Actions/spinner";
import uuid from "react-uuid";
import AlertService from "../../Services/alertService";
import {
	ERROR_KEY,
	GAMIFY_GROUP_ENTITY_TYPE_ID,
	SUCCESS_KEY,
} from "../../Constants/mainKeys";
import { GROUP_FORM_KEY } from "./../../Constants/urlKeys";
import InputCheckBox from "../../Components/Inputs/inputCheckBox";
import SmallQuestionMark from "./../../Components/SmallQuestionMark/smallQuestionMark";
import { getCurrentQuestionMarkData } from "../../Store/Actions/main";
import HelpService from "../../Services/helpService";
import ReactPaginate from "react-paginate";
import _InfoSvg from "./../../Components/Svg/_infoSvg";
import PageInfoBlock from "../../Components/PageInfoBlock/PageInfoBlock";
import GamifyApiService from "../../Services/gamifyApiService";
import GamificationItemsComponent from "../Gamification/Components/Modals/GamificationItemsComponent";

const Group = props => {
	const pageSize = 10;
	const dispatch = useDispatch();
	const translations = useSelector(state => state.translation.translations);
	const currentQuestionMarkData = useSelector(
		state => state.main.currentQuestionMarkData,
	);
	const { language } = useSelector(state => state.language);
	const { user } = useSelector(state => state.user);
	const [translationService, setTranslationService] = useState(null);
	const [groupData, setGroupData] = useState([]);
	const [group, setGroup] = useState(null);
	const [groupStudents, setGroupStudents] = useState([]);
	const [defaultStudents, setDefaultStudents] = useState([]);
	const [studentsFilterChecked, setStudentsFilterChecked] = useState(false);
	const [pagination, setPagination] = useState(null);
	const [activePageNumber, setActivePageNumber] = useState(0);

	const [setIsLoading, setIsLoadingItemId] = useState(false);
	const [gamifyData, setGamifyData] = useState(null);
	const [selectedGroup, setSelectedGroup] = useState(null);

	useEffect(() => {
		setTranslationService(new TranslationService(translations));
	}, [translations]);

	useEffect(() => {
		getGroupData(1);
	}, []);

	const handlePageClick = event => {
		getGroupData(event.selected + 1);
		setActivePageNumber(event.selected);
	};

	const redirectToCurrentGroupPage = groupId => {
		props.history.push(`/${language}/${GROUP_FORM_KEY}/${groupId}`);
	};

	const getGroupData = currentPage => {
		const spinnerId = uuid();
		dispatch(addPartialViewSpinner(spinnerId));
		ApiService.getGroupData(currentPage, pageSize)
			.then(response => {
				if (response && response.pagination)
					setPagination(JSON.parse(response.pagination));
				response.data && setGroupData(response.data);
				dispatch(removePartialViewSpinner(spinnerId));
			})
			.catch(error => getFail(error, spinnerId));
	};

	const openModal = (event, group) => {
		event && event.stopPropagation();
		if (!group) {
			return;
		}
		const spinnerId = uuid();
		setGroup(group);
		dispatch(addModalSpinner(spinnerId));
		ApiService.getGroupStudents(group.id)
			.then(response => {
				if (response.data) {
					setDefaultStudents(response.data);
					setGroupStudents(response.data);
				}
				dispatch(removeModalSpinner(spinnerId));
			})
			.catch(error => getFail(error, spinnerId));
	};

	const changeStudentAttachment = (
		groupStudents,
		checked,
		groupId,
		studentId,
	) => {
		if (!translationService) {
			return;
		}
		var create = !checked;
		const data = { create, groupId, studentId };
		const spinnerId = uuid();
		dispatch(addModalSpinner(spinnerId));
		ApiService.changeStudentAttachment(data)
			.then(() => {
				dispatch(removeModalSpinner(spinnerId));
				AlertService.alert(
					SUCCESS_KEY,
					translationService.translate("TR_DATA_SAVED"),
				);
				const groupStudentsItem = [...groupStudents];
				groupStudentsItem.forEach(groupStudent => {
					if (groupStudent.id === studentId) {
						groupStudent.isBelongToCurrentGroup =
							!groupStudent.isBelongToCurrentGroup;
					}
				});
				setGroupStudents(groupStudentsItem);
			})
			.catch(error => getFail(error, spinnerId));
	};

	const studentFilter = () => {
		if (!studentsFilterChecked) {
			var filteredStudents = groupStudents.filter(
				student => student.isBelongToCurrentGroup === true,
			);
			setGroupStudents(filteredStudents);
		} else {
			setGroupStudents(defaultStudents);
		}
		setStudentsFilterChecked(!studentsFilterChecked);
	};

	const cancel = () => {
		setGroup(null);
		setSelectedGroup(null);
		setGamifyData(null);
		setIsLoadingItemId(null);
	};

	const getQuestionMarkData = key => {
		if (!key) {
			return;
		}
		if (HelpService.setPageName(props.location.pathname)) {
			dispatch(
				getCurrentQuestionMarkData(
					HelpService.setPageName(props.location.pathname),
					key,
				),
			);
		}
	};

	const onGamifyGroup = (entityData, entityType) => {
		if (!entityData || !entityType || setIsLoading) {
			return false;
		}
		setIsLoadingItemId(entityData.id);
		const data = {
			groupId: +entityData.id,
			groupTypeId: +entityType,
		};
		GamifyApiService.onGamifyGroup(data)
			.then(response => {
				if (response && response.data) {
					setGamifyData(response.data);
					setSelectedGroup(entityData);
				}
				setIsLoadingItemId(null);
			})
			.catch(error => getFail(error));
	};

	const getFail = (error, spinnerId) => {
		error &&
			AlertService.alert(
				AlertService.checkMessageType(error.respcode) || ERROR_KEY,
				error,
			);
		spinnerId && dispatch(removePartialViewSpinner(spinnerId));
		spinnerId && dispatch(removeModalSpinner(spinnerId));
		setIsLoadingItemId(null);
		// cancel();
	};

	return translationService ? (
		<div className="container">
			<GamificationItemsComponent
				entityData={selectedGroup}
				gamifyData={gamifyData}
				entityTypeId={GAMIFY_GROUP_ENTITY_TYPE_ID}
				cancel={cancel}
			/>
			<div className="row mt-4">
				<div className="col-12">
					<h2 className="section-title">
						{translationService.translate("TR_GROUPS")}
					</h2>
					<PageInfoBlock
						pageTitle={translationService.translate("TR_GROUPS")}
						pageName="curator_groups"
						translationService={translationService}
					/>
				</div>
			</div>
			<hr />
			<div className="row">
				<div className="col-12">
					<div className="mb-2">
						<Link
							to={`/${language}/${GROUP_FORM_KEY}`}
							className="mindalay--btn-default">
							{translationService.translate("TR_CREATE_GROUP")}
						</Link>
						<SmallQuestionMark
							id="group_create_curator"
							blockClassName="ml-1"
							onMouseEnter={() => getQuestionMarkData("group_create_curator")}
						/>
					</div>
				</div>
			</div>
			{group ? (
				<ModalComponentWithoutActionButton
					title={group.organizationEducationLevelName}
					cancel={cancel}>
					<div className="row">
						<div className="col-12">
							<div className="d-flex justify-content-between align-items-center">
								<InputCheckBox
									id="withRefund"
									name="withRefund"
									checked={studentsFilterChecked}
									labelValue={translationService.translate(
										"TR_GET_ACTIVE_STUDENTS",
									)}
									onChange={studentFilter}
								/>
							</div>
							<hr className="my-2" />
						</div>
						{groupStudents && groupStudents.length ? (
							groupStudents.map(groupStudent => {
								return (
									<div key={groupStudent.id} className="col-12">
										<div className="d-flex justify-content-between align-items-center">
											<InputCheckBox
												id={groupStudent.id}
												name={"groupStudentIsBelongToCurrentGroup"}
												checked={
													groupStudent.isBelongToCurrentGroup ? true : false
												}
												labelValue={groupStudent.studentName}
												onChange={() =>
													changeStudentAttachment(
														groupStudents,
														groupStudent.isBelongToCurrentGroup,
														group.id,
														groupStudent.id,
													)
												}
											/>
										</div>
										<hr className="my-2" />
									</div>
								);
							})
						) : (
							<div className="no-data-container">
								<div className="no-data-wrapper">
									<p>
										{translationService.translate("TR_THERE_IS_NO_STUDENTS")}
									</p>
									<img src={NoDataImage} alt="/" />
								</div>
							</div>
						)}
					</div>
				</ModalComponentWithoutActionButton>
			) : null}
			{groupData && groupData.length ? (
				<div className="row">
					<div className="col-12">
						<div className="mindayal-admin-table mt-3 table-responsive">
							<table className="table">
								<thead>
									<tr>
										<th>{translationService.translate("TR_NAME")}</th>
										<th>{translationService.translate("TR_OWNER")}</th>
										<th>{translationService.translate("TR_PROGRAM_NAME")}</th>
										<th>{translationService.translate("TR_ACTIONS")}</th>
									</tr>
								</thead>
								<tbody>
									{groupData.map((group, index) => {
										return (
											<tr key={index} className="cursor-default">
												<td className="word-break-break-word">
													<div
														className="payment-name"
														onClick={event => openModal(event, group)}>
														<span>{group.groupName}</span>
													</div>
												</td>
												<td>{group.ownerName}</td>
												<td>{group.organizationEducationLevelName}</td>
												<td>
													<div className="d-flex">
														<div
															className="edit-group"
															title={translationService.translate("TR_EDIT")}
															onClick={() =>
																redirectToCurrentGroupPage(group.id)
															}>
															<div className="edit-group-item">
																<EditSvg />
															</div>
														</div>
														{user && user.isGamifyAvailable ? (
															<div
																title="Gamify"
																className="game-group ml-2"
																onClick={() =>
																	onGamifyGroup(
																		group,
																		GAMIFY_GROUP_ENTITY_TYPE_ID,
																	)
																}>
																<div className="game-group-item">
																	{setIsLoading === group.id ? (
																		<div
																			className="spinner-border text-success"
																			style={{
																				width: "15px",
																				height: "15px",
																				borderWidth: "1px",
																			}}
																		/>
																	) : (
																		<GameSvg fill="#28a745" width="20px" />
																	)}
																</div>
															</div>
														) : null}
													</div>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			) : (
				<div className="no-data-container mt-3">
					<div className="no-data-wrapper">
						<p>
							{translationService.translate("TR_YOU_HAVE_NOT_CREATED_GROUP")}
						</p>
						<img src={NoDataImage} alt="/" />
					</div>
				</div>
			)}
			{pagination ? (
				<div className="row mt-3">
					<div className="col-12">
						<div className="d-flex justify-content-end">
							<ReactPaginate
								nextLabel={translationService.translate("TR_NEXT")}
								onPageChange={handlePageClick}
								pageRangeDisplayed={3}
								marginPagesDisplayed={2}
								pageCount={pagination.TotalPages}
								previousLabel={translationService.translate("TR_PREVIOUS")}
								pageClassName="page-item"
								pageLinkClassName="page-link"
								previousClassName="page-item"
								previousLinkClassName="page-link"
								nextClassName="page-item"
								nextLinkClassName="page-link"
								breakLabel="..."
								breakClassName="page-item"
								breakLinkClassName="page-link"
								containerClassName="pagination"
								activeClassName="active"
								renderOnZeroPageCount={null}
								forcePage={activePageNumber}
							/>
						</div>
					</div>
				</div>
			) : null}
		</div>
	) : null;
};

export default withRouter(Group);
